// Library Imports
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Local Imports
import { ROUTE_PATHS, ROUTE_NAMES } from '@/router/constants';
import { CreaterDashboardLayout } from '@/components/Shared/Layouts/CreaterDashboardLayout';

const AdminDashboard = lazy(() => import('@/panels/Admin/Dashboard'));
const AdminUsers = lazy(() => import('@/panels/Admin/Users'));
const AdminUserDetail = lazy(() => import('@/panels/Admin/Users/UserDetail'));

export const adminRoutes = [
  {
    path: ROUTE_PATHS.ADMIN_ROOT,
    moduleName: ROUTE_NAMES.ADMIN_NAV,
    element: <Navigate to={ROUTE_PATHS.ADMIN_DASHBOARD} replace />,
  },
  {
    path: ROUTE_PATHS.ADMIN_DASHBOARD,
    moduleName: ROUTE_NAMES.ADMIN_DASHBOARD,
    element: (
      <CreaterDashboardLayout>
        <AdminDashboard />
      </CreaterDashboardLayout>
    ),
  },
  {
    path: ROUTE_PATHS.ADMIN_USERS,
    moduleName: ROUTE_NAMES.ADMIN_USERS,
    element: (
      <CreaterDashboardLayout>
        <AdminUsers />
      </CreaterDashboardLayout>
    ),
  },
  {
    path: ROUTE_PATHS.ADMIN_USER_DETAIL,
    moduleName: ROUTE_NAMES.ADMIN_USER_DETAIL,
    element: (
      <CreaterDashboardLayout>
        <AdminUserDetail />
      </CreaterDashboardLayout>
    ),
  },
];
